import React, { useEffect, useState } from "react";
import Container from "../../UI/Container";
import { Grid, Paper, Typography } from "@mui/material";
import TurmaTableSelectView from "../../Turma/TurmaTableSelectView";
import { findByAnoLetivo } from "../../Turma/api-turma";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import TurmaProfile from "../../Turma/TurmaProfile";
import { findByCheck } from "../api-catraca-registro";
import CatracaRegistroCheckTable from "./CatracaRegistroCheckTable";
import TextFieldDate from "../../UI/TextFieldDate";
import Button from "../../UI/Button";
import Loading from "../../UI/Loading";
import { Link } from "react-router";

const CatracaRegistroCheckContainer = () => {
  const [turmas, setTurmas] = useState([]);
  const [turma, setTurma] = useState(null);
  const [listCRC, setListCRC] = useState([]);
  const [dataSelected, setDataSelected] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    findByAnoLetivo().then((data) => {
      if (data) {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setTurmas(data);
        }
      }
    });
  }, []);

  useEffect(() => {
    if (turma) {
      fetchData();
    }

    // eslint-disable-next-line
  }, [turma]);

  const fetchData = () => {
    if (turma && dataSelected) {
      setIsLoading(true);
      findByCheck(turma.codigo, dataSelected).then((data) => {
        if (data) {
          if (data.error) {
            errorMessage(data.message);
          } else {
            setListCRC(data);
          }
        }
        setIsLoading(false);
      });
    }
  };

  const handleTrocaTurma = () => {
    setTurma(null);
  };

  const handleDateChange = (date) => {
    setDataSelected(date);
  };

  return (
    <Container component={Paper}>
      <Grid container direction="column" spacing={3}>
        <Grid>
          <Typography variant="h5">
            Monitor de Acesso Por Turma e Data
          </Typography>
        </Grid>
        <Grid>
          <Button color="secondary" component={Link} to="/monitor-acesso-menu">
            Voltar para o Menu
          </Button>
        </Grid>
        {turma ? (
          <>
            <Grid>
              <TurmaProfile turma={turma} handleTrocaTurma={handleTrocaTurma} />
            </Grid>
            <Grid>
              <TextFieldDate
                onChange={handleDateChange}
                value={dataSelected}
                label="Data"
              />
            </Grid>
            <Grid>
              <Button onClick={fetchData}>Aplicar Datas</Button>
            </Grid>
            {isLoading ? (
              <Loading description="Carregando Registros..." />
            ) : (
              <>
                {listCRC.map((catracaRegistroCheck) => (
                  <Grid>
                    <CatracaRegistroCheckTable
                      catracaRegistroCheck={catracaRegistroCheck}
                    />
                  </Grid>
                ))}
              </>
            )}
          </>
        ) : (
          <Grid>
            <TurmaTableSelectView turmas={turmas} onTurmaSelected={setTurma} />
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default CatracaRegistroCheckContainer;
